import { useMutation, useQueryClient } from '@tanstack/react-query';

import { diamondsApi } from '../api/diamonds-api';

import { diamondKeys } from './diamond-keys';

export function useDeleteStone() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (stoneId: string) => diamondsApi.deleteStone(stoneId),
    meta: { successMessage: 'diamonds:toasts.stoneDeleted' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: diamondKeys.stones() }),
  });
}
